module.exports = __webpack_public_path__ + "static/media/whatsapp.7061f03d.png";